import type { StaffRole } from "@lafayette/auth";
import { useMemo } from "react";

import { type CapabilityRules, capabilityFlags } from "../access/capabilities";
import { useStaffRoles } from "../access/use-staff-roles";

// What a staff member may do on the Operations page. Presentation only: the API decides every request again.

export type OperationsCapabilities = Readonly<{
  /** `operations.jobs.read` */
  read: boolean;
  /** `operations.jobs.manage` */
  manage: boolean;
}>;

const operationsCapabilityRules = {
  read: "operations.jobs.read",
  manage: "operations.jobs.manage",
} as const satisfies CapabilityRules;

export function operationsCapabilitiesForRoles(
  roles: readonly StaffRole[],
): OperationsCapabilities {
  return capabilityFlags(operationsCapabilityRules, roles);
}

export function useOperationsCapabilities(): Readonly<{
  capabilities: OperationsCapabilities;
  isLoading: boolean;
}> {
  const { roles, isLoading } = useStaffRoles();
  const capabilities = useMemo(() => operationsCapabilitiesForRoles(roles), [roles]);
  return { capabilities, isLoading };
}
